import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupNames } from '../enums/lookups-names.enum';
import { CountryCode } from '../models/country';
import { Lookup } from '../models/lookup';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  private url!: string;

  constructor(private http: HttpClient, @Inject('env') private env: any) {
    this.url = env.api;
  }

  private fillEnglishNames<T extends Lookup>(items: T[]): T[] {
    return items.map(item => {
      if (!item.nameEN) { item.nameEN = item.name; (item as any).nameEn = item.name; }
      return item;
    });
  }

  postGuradForm(Form: any): Observable<any> {
    return this.http.post(this.url + `api/SecurityGuard/CreateOld`, Form);
  }
  postExistGuard(Form: any): Observable<any> {
    return this.http.post(this.url + `api/CompanySecurityGuard/Add`, Form);
  }
  getNationality(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(this.url + `api/Nationality/GetAll`).pipe(map(items => this.fillEnglishNames(items)));
  }
  getCountries(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.country}`
    );
  }
  getBloodType(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.bloodType}`
    );
  }

  getCity(nationalityId?: string): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.city}${
          nationalityId ? `&id=${nationalityId}` : ''
        }`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getGender(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.gender}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getJobType(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.jobType}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getAreas(cityId: string): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.area}&id=${cityId}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getAvailableServices(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.availableServices}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getCompanyScale(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.companyScale}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getFinanceYear(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.financeYear}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getTimeZone(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.timeZone}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getCountriesCodes(): Observable<CountryCode[]> {
    return this.http.get<CountryCode[]>(this.url + `api/Country/GetAllCountry`);
  }

  getCompanyType(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.companyType}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getBusinessTypes() {
    return this.http.get<Lookup[]>(this.url + `api/BusinessType/GetAll`).pipe(map(items => this.fillEnglishNames(items)));
  }

  getShiftType(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.shiftType}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }
  getTimeType(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(
      this.url +
        `api/Lookup/public/lookup/getLookup?lookupName=${LookupNames.timeType}`
    ).pipe(map(items => this.fillEnglishNames(items)));
  }

  getAllJobTypes(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(this.url + `api/JobType/GetAll`).pipe(map(items => this.fillEnglishNames(items)));
  }

  getAllAvailableServices(): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(this.url + `api/AvailableServices/GetAll`).pipe(map(items => this.fillEnglishNames(items)));
  }
}
